import React from "react";
import NavBar from "../components/NavBarFirst";
import LandingPage from "../components/LandingPageFirst";
import JustForSection from "../components/JustForSection";

function HomeFirst() {
  return (
    <div>
      <NavBar />
      <LandingPage />
      <JustForSection />
    </div>
  );
}

export default HomeFirst;
